import * as Base64Encoder from './vendor/typescript-base64-arraybuffer';
/**
 * Contains helper methods for serializing/deserializing coral timestamps, blobs, and primitives
 * into Dates, Uint8Array, and corresponding primitive instances respectively.
 */
export class SerdesUtils {
    static identityFunction(val) {
        return val;
    }
    static dateToJson(date) {
        return date.getTime() / 1000;
    }
    static blobToJson(blob) {
        return Base64Encoder.encode(blob.buffer);
    }
    static jsonToDate(timestamp) {
        return new Date(timestamp * 1000);
    }
    static jsonToBlob(blob) {
        return Base64Encoder.decode(blob);
    }
}
